import { Box, Table } from '@factorialco/deprecated-design-system'
import { WorkScheduleScheduleFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import TableBody from './Body'
import TableHeader from './Header'
import TitleBar from './TitleBar'

interface Props {
  schedule: WorkScheduleScheduleFragment
  archived?: boolean
  disabled?: boolean
  canAssignEmployees: boolean
  hasFixedWorkSchedulesEnabled: boolean
}

const WorkScheduleTable = ({
  schedule,
  archived,
  disabled = false,
  canAssignEmployees,
  hasFixedWorkSchedulesEnabled,
}: Props) => {
  return (
    <Box width="full" overflowY="visible">
      <TitleBar
        archived={archived}
        schedule={schedule}
        disabled={disabled}
        canAssignEmployees={canAssignEmployees}
        hasFixedWorkSchedulesEnabled={hasFixedWorkSchedulesEnabled}
      />
      <Table fullWidth overflowY="auto" autoLayout noTopRadius>
        <TableHeader />
        <TableBody periods={schedule.overlapPeriods} />
      </Table>
    </Box>
  )
}

export default observer(WorkScheduleTable)
